import OutlinedTextField from '../../textboxes/OutlinedTextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import * as React from 'react';
import { AuthenticationType } from '../../../types';

interface Props {
  issuer: string;
  clientId: string;
  clientSecret: string;
  authenticationType?: AuthenticationType;
  onChangeSSOTextfields?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const OIDCInputs = (props: Props) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const isD1P = props.authenticationType === AuthenticationType.D1P_OIDC;

  return (
    <div className="authentication-admin-sso-menu-inputs">
      <OutlinedTextField
        testid={'oidc-issuer-uri'}
        id="issuer"
        label={'Issuer URI'}
        placeholder={'https://example.com/.well-known/openid-configuration'}
        value={props.issuer}
        onChange={props.onChangeSSOTextfields}
        helperText={
          'The Issuer URI for OpenID, used by the provider as the Issuer Identifier.'
        }
      />
      <OutlinedTextField
        testid={'oidc-client-id'}
        id="client_id"
        label={'Client ID'}
        placeholder={'Enter your Client ID'}
        value={props.clientId}
        onChange={props.onChangeSSOTextfields}
        helperText={'The ID used to identify the client application.'}
      />
      {!isD1P && (
        <OutlinedTextField
          testid={'oidc-client-secret'}
          id="client_secret"
          label={'Client Secret'}
          placeholder={'Enter your Client Secret'}
          value={props.clientSecret}
          onChange={props.onChangeSSOTextfields}
          helperText={'The Client Secret used to securely share information.'}
          type={showPassword ? 'text' : 'password'}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                edge="end"
                size="large"
              >
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      )}
    </div>
  );
};

export default OIDCInputs;
